import { PageContainer, PageHeader, Spread, VStack } from '@/components/Atoms'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/Card'
import {
  CreateCrtPeriodDetailsDialog,
  getDefaultImportPeriod,
} from '@/components/CreateCrtPeriodDetailsDialog'
import PermissionsGuard from '@/components/Guard/PermissionsGuard'
import {
  salesDealActualsSearchSchema,
  useCreateSalesDealActuals,
} from '@/hooks/queries/crt/useSalesDealActuals'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import SalesDealActualsDataTable from './-components/SalesDealActualsDataTable'

export const Route = createFileRoute(
  '/_auth/_modules/crt/customer-investments/insights/sales-deal-actuals/',
)({
  component: RouteComponent,
  validateSearch: (search) => salesDealActualsSearchSchema.parse(search),
})

function RouteComponent() {
  const { t } = useTranslation('crt')
  const search = Route.useSearch()
  const [isOpen, setIsOpen] = useState(false)

  const { isPending, mutate } = useCreateSalesDealActuals({
    queries: search,
    handleOnSuccess: () => setIsOpen(false),
  })

  return (
    <PageContainer>
      <Spread>
        <PageHeader>{t('salesDealActuals.pageHeader')}</PageHeader>
        <PermissionsGuard required={['crt_sales_deal_actuals_create']}>
          <CreateCrtPeriodDetailsDialog
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            triggerLabel={t('salesDealActuals.createButton')}
            title={t('createSalesDealActualsDialog.title')}
            nameLabel={t('createSalesDealActualsDialog.name.label')}
            namePlaceholder={t('createSalesDealActualsDialog.name.placeholder')}
            isPending={isPending}
            crtPeriodLabel={t('period')}
            defaultCrtPeriod={getDefaultImportPeriod()}
            onSubmit={({ name, description, crtPeriod }) =>
              mutate({ name, description, period: crtPeriod })
            }
          />
        </PermissionsGuard>
      </Spread>

      <Card>
        <CardHeader>
          <CardTitle>{t('salesDealActuals.cardTitle')}</CardTitle>
        </CardHeader>

        <CardContent>
          <VStack gap="md">
            <SalesDealActualsDataTable />
          </VStack>
        </CardContent>
      </Card>
    </PageContainer>
  )
}
